(function webpackUniversalModuleDefinition(root, factory) {
	if(typeof exports === 'object' && typeof module === 'object')
		module.exports = factory();
	else if(typeof define === 'function' && define.amd)
		define("dplayer-lite", [], factory);
	else if(typeof exports === 'object')
		exports["dplayer-lite"] = factory();
	else
		root["dplayer-lite"] = factory();
})(self, () => {
return 